import { useQueryClient } from '@tanstack/react-query';

export const useClearCacheCallback = (cacheKey: Array<string> | undefined) => {
  const client = useQueryClient();

  return () => {
    if (cacheKey) {
      cacheKey.forEach((key: string) => {
        client.invalidateQueries({
          queryKey: [key],
        });
      });
    } else {
      client.invalidateQueries();
    }
  };
};
